(() => {
  if (window.spotmateMenuFocus) return;
  window.spotmateMenuFocus = true;
  const root = document.documentElement;
  document.addEventListener('pointerdown', () => {
    root.dataset.menuInput = 'pointer';
  }, { capture: true, passive: true });
  document.addEventListener('keydown', event => {
    if (['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Escape'].includes(event.key)) {
      root.dataset.menuInput = 'keyboard';
    }
  }, true);
})();
